import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { QualificationTypeCounts, adaptQualificationCounts, qualificationCountTotal } from "@core/models/organisation/qualification.model";

export interface OrganisationTeam{
  
  id:string;
  name:string;
  memberCount?:number;
  // Qualification requirements linked to the team, per type (collection payload only).
  qualificationCounts?:QualificationTypeCounts;
  // The same requirements as one number: every type together.
  qualificationCount?:number;
  /** Budgets set for this team, so the list can say so without opening the dialog. */
  budgetCount?:number;
  manager?:boolean;
  member?:boolean;

}

@Injectable({
  providedIn: 'root'
})

export class OrganisationTeamAdapter implements Adapter<OrganisationTeam> {
  adapt(item:any, manager:boolean = false){
    
    return { 
      id: item.id, 
      name:item.name,
      memberCount:item.memberCount,
      qualificationCounts:adaptQualificationCounts(item.qualificationCounts),
      qualificationCount:qualificationCountTotal(adaptQualificationCounts(item.qualificationCounts)),
      budgetCount:item.budgetCount ?? 0,
      manager:manager

    } as OrganisationTeam
  }
}
